import React, { useCallback } from "react";
import { useParams } from "react-router-dom";

import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import DetailsPageHeader from "../../components/shared/DetailsPageHeader";
import Fetcher from "../../components/shared/FetcherComponent";
import VacancyBasicInfoBlock from "../../components/vacancyPage/vacancyDetailsPage/VacancyBasicInfoBlock";
import VacancyDetailsBlock from "../../components/vacancyPage/vacancyDetailsPage/VacancyDetailsBlock";
import VacancyAboutUniversityBlock from "../../components/vacancyPage/vacancyDetailsPage/VacancyAboutUniversityBlock";
import VacancyRequirementsBlock from "../../components/vacancyPage/vacancyDetailsPage/VacancyRequirementsBlock";
import VacancySectionBlock from "../../components/vacancyPage/vacancyDetailsPage/VacancySectionBlock";

import vacancyService from "../../services/vacancyService";
import { useVacancyPageContext } from "../../hooks/useVacancyPageContext";
import { LANGUAGE_KEYS } from "../../utilities/constants";

const VacancyDetailsPage = () => {
  const { vacancyId } = useParams();
  const { singleVacancy, setSingleVacancy } = useVacancyPageContext();

  const fetchVacancy = useCallback(
    async () => await vacancyService.getVacancyById(vacancyId),
    [vacancyId]
  );

  const handleOnLoadFetchedVacancy = useCallback(
    (response) => setSingleVacancy(response),
    [setSingleVacancy]
  );

  return (
    <>
      <Head title="Vacancy Details" />
      <Content>
        <Fetcher action={fetchVacancy} onLoad={handleOnLoadFetchedVacancy}>
          <DetailsPageHeader
            title={"Vacancy -"}
            name={singleVacancy?.jobTitle?.[LANGUAGE_KEYS.EN]}
            createdDate={singleVacancy?.createdAt}
            goBackPath={"/vacancies"}
          />
          <VacancyBasicInfoBlock />
          <VacancyDetailsBlock />
          <VacancyAboutUniversityBlock />
          <VacancySectionBlock
            sectionTitle="Disciplines"
            field="disciplines"
            listKey="arguments"
            listLabel="Items"
            addButtonTitle="Add discipline"
          />
          <VacancySectionBlock
            sectionTitle="Application Process"
            field="applicationProcess"
            listKey="arguments"
            listLabel="Items"
            addButtonTitle="Add step"
          />
          <VacancyRequirementsBlock />
        </Fetcher>
      </Content>
    </>
  );
};

export default VacancyDetailsPage;
